import { Avatar, AvatarFallback } from '@/components/ui/avatar'

interface TeamMemberChipProps {
  name: string
  roles: string[]
}

function getInitials(name: string): string {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

export function TeamMemberChip({ name, roles }: TeamMemberChipProps) {
  const roleLabel = roles.length > 0 ? roles.join(', ') : ''

  return (
    <div
      className="flex h-10 items-center gap-2 rounded-full border border-border bg-background pr-4"
      data-testid="team-member-chip"
    >
      <Avatar className="h-10 w-10 border-[1.5px] border-border">
        <AvatarFallback className="bg-primary text-sm font-bold leading-[1.3] tracking-[0.015em] text-primary-foreground">
          {getInitials(name)}
        </AvatarFallback>
      </Avatar>
      <div className="flex flex-col">
        <span className="text-sm font-normal leading-[1.3] tracking-[0.015em] text-card-foreground">
          {name}
        </span>
        {roleLabel && (
          <span className="text-xs font-normal leading-[1.4] tracking-[0.015em] text-card-foreground">
            {roleLabel}
          </span>
        )}
      </div>
    </div>
  )
}
